import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const Footer = () => {
    const faqData = [
        {
            question: 'Yazılım geliştirme süreciniz nasıl işliyor?',
            answer: 'Projelerimizi analiz, tasarım, geliştirme, test ve devreye alma aşamalarında yürütüyoruz. Her aşamada müşterimizle yakın iletişim halinde olarak, ihtiyaçlara uygun çözümler geliştiriyoruz.'
        },
        {
            question: 'Hangi platformlar için yazılım geliştiriyorsunuz?',
            answer: 'Web uygulamaları, iOS ve Android mobil uygulamaları, masaüstü uygulamaları ve kurumsal yazılım çözümleri geliştiriyoruz. Modern teknolojiler kullanarak cross-platform çözümler de sunuyoruz.'
        },
        {
            question: 'Yazılım geliştirme süresi ne kadar sürer?',
            answer: 'Proje karmaşıklığına göre değişmekle birlikte, basit projeler 2-4 hafta, orta ölçekli projeler 2-4 ay, büyük ölçekli projeler 6+ ay sürebilir. Detaylı zaman planını proje analizi sonrası paylaşıyoruz.'
        },
        {
            question: 'Destek ve bakım hizmetleri sunuyor musunuz?',
            answer: 'Evet, tüm projelerimiz için sürekli destek ve bakım hizmetleri sunuyoruz. Güvenlik güncellemeleri, performans optimizasyonu ve yeni özellik ekleme konularında destek veriyoruz.'
        },
        {
            question: 'Projem için özel yazılım çözümleri geliştirebilir misiniz?',
            answer: 'Tabii ki! Her müşterimizin ihtiyaçları farklıdır. İşletmenizin özel gereksinimlerine göre tamamen özelleştirilmiş yazılım çözümleri geliştiriyoruz.'
        },
        {
            question: 'Yazılım geliştirme maliyetleriniz nedir?',
            answer: 'Maliyetler projenin kapsamı, karmaşıklığı ve süresine göre değişir. Ücretsiz danışmanlık görüşmesi sonrası size özel bir teklif hazırlıyoruz. Şeffaf fiyatlandırma politikamız vardır.'
        }
    ];

    return (
        <footer className="bg-gray-900 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="mb-16">
                    <h2 className="text-3xl font-bold text-center mb-12">
                        Sıkça Sorulan Sorular
                    </h2>

                    <Accordion.Root type="single" collapsible className="max-w-4xl mx-auto">
                        {faqData.map((item, index) => (
                            <Accordion.Item
                                key={index}
                                value={`item-${index}`}
                                className="border-b border-gray-700 last:border-b-0"
                            >
                                <Accordion.Header>
                                    <Accordion.Trigger className="flex justify-between items-center w-full py-6 text-left hover:text-primary-400 transition-colors duration-200 group">
                                        <span className="text-lg font-medium pr-4">
                                            {item.question}
                                        </span>
                                        <ChevronDownIcon className="h-5 w-5 text-gray-400 group-hover:text-primary-400 transition-all duration-200 group-data-[state=open]:rotate-180" />
                                    </Accordion.Trigger>
                                </Accordion.Header>
                                <Accordion.Content className="pb-6 text-gray-300 leading-relaxed">
                                    {item.answer}
                                </Accordion.Content>
                            </Accordion.Item>
                        ))}
                    </Accordion.Root>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
                    <div className="md:col-span-2">
                        <div className="mb-6">
                            <span className="text-3xl font-bold text-primary-400">SAGTEK Yazılım</span>
                        </div>
                        <p className="text-gray-300 mb-6 leading-relaxed">
                            Modern teknolojilerle yazılım çözümleri geliştiren, müşteri memnuniyetini
                            ön planda tutan bir yazılım firmasıyız. Dijital dönüşüm yolculuğunuzda
                            güvenilir ortağınızız.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-6">Hızlı Linkler</h3>
                        <ul className="space-y-3">
                            <li><a href="#home" className="text-gray-300 hover:text-primary-400 transition-colors duration-200">Ana Sayfa</a></li>
                            <li><a href="#about" className="text-gray-300 hover:text-primary-400 transition-colors duration-200">Hakkımızda</a></li>
                            <li><a href="#services" className="text-gray-300 hover:text-primary-400 transition-colors duration-200">Hizmetlerimiz</a></li>
                            <li><a href="#projects" className="text-gray-300 hover:text-primary-400 transition-colors duration-200">Projelerimiz</a></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-6">İletişim</h3>
                        <ul className="space-y-3 text-gray-300">
                            <li>
                                <a href="tel:+905551456621" className="hover:text-primary-400 transition-colors duration-200">
                                    +90 555 145 66 21
                                </a>
                            </li>
                            <li>
                                <a href="mailto:bilgi.sagtek@gmail.com" className="hover:text-primary-400 transition-colors duration-200">
                                    bilgi.sagtek@gmail.com
                                </a>
                            </li>
                            <li>Batman Teknokent Kat: 1 No: 101</li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-700 pt-8">
                    <div className="text-center">
                        <p className="text-gray-400 text-sm">
                            © {new Date().getFullYear()} SAGTEK Yazılım. Tüm hakları saklıdır.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
